<script>
    import { replace } from "svelte-spa-router";
    import { loop_guard } from "svelte/internal";
    import { fade, fly } from "svelte/transition";
    import DefaultButton from "../../components/DefaultButton.svelte";
    import Logo from "../../components/Logo.svelte";

    export let title = "";
    export let backgroundColor = "var(--white-100)";
    export let hideSeperator = false;
    export let showTitleAlways = false;
    export let linkCopied;
    export let flexHeader;
    export let onSite = false;
    export let hideLogo = false;

    let scrollY = 0;
</script>

<svelte:window bind:scrollY />

<div class={flexHeader ? "header-bar__wrapper" : "header-bar__wrapper2"}>
    <div
        class={flexHeader ? "header-bar__container" : "header-bar__container2"}
        style="background:{backgroundColor}"
    >
        <div class={flexHeader ? "left-container" : "left-container2"}>
            <slot name="pre-title" />
        </div>
        <div class={flexHeader ? "middle-container" : "middle-container2"}>
            {#if linkCopied}
                <div
                    transition:fade|local={{ duration: 300 }}
                    class="header-bar__title headline-xs"
                    style="position:absolute;"
                >
                    <DefaultButton text="Link Kopiert!" isSmall />
                </div>
            {/if}
            {#if scrollY > 0 || showTitleAlways}
                <div
                    transition:fade|local={{ duration: 600 }}
                    class="header-bar__title headline-xs"
                >
                    {title}
                </div>
                <div style="display:none">{(linkCopied = false)}</div>
            {:else if !hideLogo}
                <Logo
                    oneLine
                    on:click={() => replace(onSite ? "/onsite" : "/")}
                />
            {:else}
                <div />
            {/if}
        </div>
        <div class={flexHeader ? "right-container" : "right-container2"}>
            <slot name="post-title" />
        </div>
    </div>
    {#if scrollY > 0 && !hideSeperator}
        <div
            transition:fly|local={{ x: -375, duration: 600 }}
            class="divider-h"
        />
    {/if}
</div>

<div class="disp-small" style="height: 72px; width: 100vw;" />

<style>
    .header-bar__wrapper {
        position: fixed;
        width: 100%;
        left: 0;
    }

    .header-bar__wrapper2 {
        position: fixed;
        width: 100%;
        left: 0;
    }

    .header-bar__container {
        height: 76px;
        padding-left: 24px;
        padding-right: 24px;
        display: grid;
        grid-template-columns: 1fr 3fr 1fr;
        z-index: 1;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
    }

    .header-bar__container2 {
        height: 76px;
        padding-left: 24px;
        padding-right: 24px;
        display: grid;
        grid-template-columns: 1fr 3fr 1fr;
        z-index: 1;
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
    }

    .middle-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .left-container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .right-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .middle-container2 {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .left-container2 {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .right-container2 {
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    .header-bar__title {
        text-align: center;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    @media (min-width: 1440px) {
        .header-bar__wrapper2 {
            position: unset;
            height: 60px;
        }

        .header-bar__container2 {
            padding: 0 16px;
            height: 60px;
        }

        .disp-small {
            display: none;
        }

        .middle-container2 {
            align-items: start;
        }

        .left-container2 {
            align-items: start;
        }

        .right-container2 {
            align-items: start;
        }
    }
</style>
